import { Action, createReducer, on } from '@ngrx/store';

import { SessionHandoffActions } from '../actions';
import { SessionHandoffState } from '../state';

const reducer = createReducer(
  SessionHandoffState.initialState,
  on(SessionHandoffActions.AddAssociatedUser, (state, { payload }): SessionHandoffState.State => ({
    ...state,
    associatedUsers: [...new Set([...state.associatedUsers, payload.packageUserGuid])],
  }))
);

export function sessionHandoffReducer(
  state: SessionHandoffState.State | undefined,
  action: Action
): SessionHandoffState.State {
  return reducer(state, action);
}
